import React, {useState, useEffect} from "react";
import {Button, Paper, Box, Autocomplete, TextField, Typography} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import commonService from "../../services/common-service";
import Spinner from "../../shared/Spinner";
import SnackAlert from "../../shared/SnackAlert";
import { useParams } from "react-router-dom";

export default function EnforcementZone() {
    const {domain} = useParams();
    const [installations, setInstallations] = useState([]);
    const [groups, setGroups] = useState([]);
    const [inputField, setInputField] = useState({});
    const [selectedIns, setSelectedIns] = useState(null);
    const [selectedGrp, setSelectedGrp] = useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [alert, setAlert] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [severity, setSeverity] = React.useState('');
    const [lastIds, setLastIds] = useState({});
    
    const handleChange=(e) => {
        setInputField({...inputField, [e.target.name]: e.target.value});
    }

    const get_last_ids=async() => {
        setSpinner(true);
        const res = await commonService.get_last_ids({domain: domain});
        const obj = {
            ticket_str_id : parseInt(res.data[13].ticket_str_id)+1,
            ticket_grp_id : parseInt(res.data[14].ticket_grp_id)+1,
            ticket_grhi_id : parseInt(res.data[16].ticket_grhi_id)+1
        };
        setLastIds(obj);
        setSpinner(false);
    }
    const getInstalltions=async() => {
        setSpinner(true);
        const user = JSON.parse(sessionStorage.getItem('userLogged'));
        let body = {domain: domain};
        if(user.email == "cwpadmin"){
            body.ins_description = 'cwp'
        }
        const res = await commonService.get_installtions(body);
        setInstallations(res.data);
        setSpinner(false);
    }

    const onInsSelect=async(newValue) => {
        setSpinner(true);
        setSelectedIns(newValue);
        const res = await commonService.get_groups_by_ins_id({ins_id: newValue.ins_id, domain: domain});
        setGroups(res.data);
        setSelectedGrp(null);
        setSpinner(false);
    }

    const handleSubmit=async(e) => {
        e.preventDefault();
        setSpinner(true);
        let ticketGroup = "INSERT INTO STREETS (STR_ID, STR_DESCRIPTION, STR_INS_ID, STR_LOOKUP_DESCRIPTION)\n"+
        "VALUES ("+lastIds.ticket_str_id+", '"+selectedGrp.GRP_DESCRIPTION+"', "+selectedIns.ins_id+", '"+selectedGrp.GRP_DESCRIPTION+"');\n\n"+
        "INSERT INTO GROUPS (GRP_ID, GRP_DESCRIPTION, GRP_INS_ID, GRP_QUERY_EXT_ID, GRP_EXT1_ID, GRP_EXT2_ID, GRP_EXT3_ID, GRP_STR_ID)\n"+
        "VALUES ("+lastIds.ticket_grp_id+", '"+selectedGrp.GRP_DESCRIPTION+"', "+selectedIns.ins_id+", "+selectedGrp.grp_id+", "+selectedGrp.grp_id+", "+selectedGrp.grp_id+", "+selectedGrp.grp_id+", "+lastIds.ticket_str_id+");\n\n";
        let ticket_grhi = "INSERT INTO GROUPS_HIERARCHY (GRHI_ID, GRHI_GRP_ID, GRHI_INI_APPLY_DATE, GRHI_END_APPLY_DATE)\n"+
        "VALUES ("+lastIds.ticket_grhi_id+","+lastIds.ticket_grp_id+", TO_DATE('12/16/2021', 'mm/dd/yyyy') ,TO_DATE('1/1/2050', 'mm/dd/yyyy'));";
        let obj = {
            group: ticketGroup,
            ticket_grhi: ticket_grhi
        }
        let arr = [];
        Object.keys(obj).map(function(key, index) {
            let tempArray = obj[key].replace(/\n/g, '').split(";");
            arr = arr.concat(tempArray.filter(function (el) {return el != "";}))
        });
        let body = {
            domain: domain,
            query: arr
        }
        const res = await commonService.insert_to_ticket(body);
        if(res.data == true){
            setMsg("Zone Added Successfully");
            setSeverity('success');
            setSelectedGrp(null);
            setSelectedIns(null);
        }else{
            let result = res.data.split('</div>');
            let errArray = JSON.parse(result[result.length-1].replace('\n',''));
            setMsg(errArray.map(x=>{return x}).join('\n\n'))
            setSeverity('error');
        }
        setAlert(true);
        setSpinner(false);
    }

    useEffect(()=>{
        getInstalltions();
        get_last_ids();
    },[])

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <Typography variant="body1" className="font-bold">Enforcement zone</Typography>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={installations}
                                            getOptionLabel={(option) => option.ins_description}
                                            name="selectedIns"
                                            value={selectedIns}
                                            onChange={(event, newValue)=>onInsSelect(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="City" variant="standard" 
                                                className="width-90" 
                                                required
                                            />}
                                    />
                                    </div>
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={groups}
                                            getOptionLabel={(option) => option.GRP_DESCRIPTION}
                                            name="selectedIns"
                                            value={selectedGrp}
                                            onChange={(event, newValue)=>setSelectedGrp(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="Zone" variant="standard" 
                                                className="width-90" 
                                                required
                                            />}
                                    />
                                    </div>
                                </div>
                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    <Button type="button" className="me-2" onClick={()=>{window.location.reload()}}>
                                        Reset
                                    </Button>
                                    <Button type="submit" className="btn btn-blue px-3 fit-content">
                                        Add Zone
                                    </Button>
                                </Box>
                            </form>
                        </Paper>
                    </div>
                </div>
            </div>
            <Spinner
                spinner = {spinner}
            />
            <SnackAlert 
                msg={msg}
                alert={alert}
                severity={severity}

                closeAlert={()=>setAlert(false)}
            />
        </div>
    );
}
